import { render, staticRenderFns } from "./GeneralSearchBar.vue?vue&type=template&id=20c0bc9a&scoped=true&"
import script from "./GeneralSearchBar.vue?vue&type=script&lang=js&"
export * from "./GeneralSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSearchBar.vue?vue&type=style&index=0&id=20c0bc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0bc9a",
  null
  
)

export default component.exports